"use strict";

module.exports = class password {
	constructor() {
		this.togglePassword = document.querySelectorAll('[data-toggle="password"]');
		this.isEdge = navigator.userAgentData !== undefined && JSON.stringify(navigator.userAgentData).indexOf('Edge') > 0;
		if(this.isEdge) {
			this.togglePassword.forEach(el => el.remove());
		} else {
			this.toggle();
		}
	}
	toggle() {
		this.togglePassword.forEach(el => el.addEventListener('click', function (e) {
			const password = document.getElementById(this.previousElementSibling.id);
			const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
			password.setAttribute('type', type);
			this.classList.toggle('bi-eye');
		}));
	}
}
